/**
 * Created by rak on 1/15/2016.
 */
'use strict';
angular.module('trackMap', ['ui.router']).config(function ($stateProvider) {

  $stateProvider
    .state('trackMap', {
      parent: 'betotrack',
      url: '/map',
      views: {
        'content@app': {
          controller: 'MappingGroupCtrl',
          templateUrl: 'components/track/mapping/groupMap.tpl.html'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Map';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      },
      ncyBreadcrumb: {
        label: ''
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/track/mapping/betoTrackMapping.js